import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  extraclass?: string
  widthAuto?: boolean
  textSize?: 'small' | 'normal' | 'large'
  error?: boolean
}

export const Input = (props: InputProps) => {
  return (
    <input className={`${!props.widthAuto ? 'w-full ' : ''}${props.textSize === 'small' ? 'text-xs md:text-sm' : props.textSize === 'large' ? 'md:text-lg' : 'text-sm md:text-base'} border ${props.error ? 'focus:border-red-400' : 'focus:border-black'} rounded-lg p-1.5 outline-none ` + (props.extraclass || '')} {...props} />
  )
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  extraclass?: string
  textSize?: 'small' | 'normal' | 'large'
  ref?: React.Ref<HTMLTextAreaElement>
  error?: boolean
}

export const Textarea = (props: TextareaProps) => {
  return (
    <textarea ref={props.ref} rows={5} className={`w-full ${props.textSize === 'small' ? 'text-xs md:text-sm' : props.textSize === 'large' ? 'md:text-lg' : 'text-sm md:text-base'} border resize-none ${props.error ? 'focus:border-red-400' : 'focus:border-black'} rounded-lg p-1.5 outline-none ` + (props.extraclass || '')} {...props} />
  )
}